import { equationCatalog } from "../knowledge/equationCatalog.js";

export const evidenceStatuses = [
  "SOURCE_ANCHORED",
  "OPERATOR_MODEL",
  "DRAFT",
  "NEEDS_CORPUS_AUDIT",
  "NEEDS_EXPERIMENT",
  "NEEDS_SOURCE_TERMS_REVIEW",
  "LICENSED_SOURCE_NEEDED",
  "SOURCE_REVIEW_NEEDED",
  "REJECT_AS_LITERAL"
];

export const operatorRegistry = equationCatalog.map((equation) => ({
  id: equation.id,
  label: equation.label,
  equation: equation.formula,
  statuses: equation.status,
  lifecycleState: equation.lifecycleState,
  version: equation.version,
  introducedAt: equation.introducedAt,
  versionBoundary: `${equation.version}@${equation.lifecycleState}`,
  boundary: equation.blockedClaims.join("; "),
  sourceAnchors: equation.anchors
}));
